<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Products
      <div slot="right" class="navbar-message button-gap-right-aligned">
        <div class="hero-navbar-right-flex">
          <multiselect
            :disabled="switchCustomerViewEnabled"
            :value="tenatSchemas.id"
            v-model="customer"
            :options="tenatSchemas"
            placeholder="Please select a customer"
            label="name"
            track-by="name"
            :searchable="true"
            @input="changeCustomer()"
          ></multiselect>

          <b-button
            type="is-primary"
            class="import-button"
            @click="backToImportForm"
            v-if="isEditAllowed"
          >
            Import Products Data</b-button
          >
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <section class="has-listing-table">
        <div class="level no-margin" v-if="customer">
          <div class="level-left bulk-actions">
            <span class="navbar-item">
              <a
                @click.prevent="additionalBulkCheck('exportProducts')"
                data-cy="pd-bulk-edit"
                >Export</a
              >
            </span>

            <span class="navbar-item" v-if="isEditAllowed">
              <a @click="editBulkModal()" data-cy="pd-bulk-edit">Edit</a>
            </span>
            <span
              class="navbar-item"
              v-if="isEditAllowed && stream === 'PRODUCT SHEET'"
            >
              <a @click="deactivateBulkModal()" data-cy="pd-bulk-deactivate"
                >Deactivate</a
              >
            </span>
            <span class="navbar-item" v-if="isEditAllowed">
              <a @click="openDataCompletionModal()" data-cy="data-completion"
                >Data Completion</a
              >
            </span>

            <span class="navbar-item">
              <a
                @click.prevent="revertDataCompletionRule('revert')"
                data-cy="pd-bulk-edit"
                v-if="isEditAllowed"
                >Revert</a
              >
            </span>

            <span
              class="navbar-item"
              v-if="this.userExternalCheck() || this.switchCustomerView"
            >
              <a @click.prevent="BulkComments()" data-cy="pd-bulk-comment"
                >Comment</a
              >
            </span>
            <span class="navbar-item">
              <a
                @click.prevent="completeProductExport('exportProducts')"
                data-cy="pd-bulk-edit"
                v-if="this.customer"
                >Export All CDF sheets</a
              >
            </span>
            <span class="navbar-item" v-if="isEditAllowed && customer">
              <a
                @click="openAddProductModal"
                data-cy="pd-add-product"
                v-if="stream === 'PRODUCT SHEET'"
                >Add Product</a
              >
            </span>
          </div>
          <!-- Column Configuration Dropdown -->
          <div class="level-right">
            <template>
              <b-field>
                <b-select
                  placeholder="Default"
                  expanded
                  @input="changeStream()"
                  v-model="stream"
                >
                  <option selected value="PRODUCT SHEET">Products</option>
                  <option value="BATT" v-if="availableStream['BATT']">
                    Batteries
                  </option>
                  <option value="PACK" v-if="availableStream['PACK']">
                    Packaging
                  </option>
                  <option value="WEEE" v-if="availableStream['WEEE']">
                    WEEE
                  </option>
                  <option
                    value="BUNDLE INFORMATION"
                    v-if="availableStream['BUNDLE']"
                  >
                    Bundle
                  </option>
                </b-select>
              </b-field>
            </template>
            <b-dropdown position="is-bottom-left" style="margin-bottom: 10px;">
              <template #trigger>
                <a class="navbar-item navbar-mdi-tune-dropdown">
                  <button class="button" data-cy="validation-config-button">
                    <span class="mdi mdi-table-cog mdi-24px mdi-dark"></span>
                  </button>
                </a>
              </template>
              <form>
                <div class="filter-config-modal-body">
                  <section class="filter-config-list">
                    <span>
                      <b-field label="Column Configuration"></b-field>
                    </span>
                    <div class="control">
                      <b-dropdown-item
                        aria-role="list"
                        :focusable="false"
                        custom
                        paddingless
                      >
                        <b-checkbox
                          @input="toggleSelectAll()"
                          v-model="selectAll"
                          @click.stop
                        >
                          <strong>Select All</strong>
                        </b-checkbox>
                      </b-dropdown-item>
                    </div>
                    <div
                      v-for="(column, index) in columns"
                      :key="index"
                      class="control"
                    >
                      <div v-if="column.label != ''">
                        <b-dropdown-item
                          aria-role="list"
                          :focusable="false"
                          custom
                          paddingless
                        >
                          <b-checkbox
                            @input="saveFieldConfig()"
                            v-model="column.visible"
                          >
                            {{ column.label }}
                          </b-checkbox>
                        </b-dropdown-item>
                      </div>
                    </div>
                  </section>
                </div>
              </form>
            </b-dropdown>
          </div>
        </div>
        <div class="enable-select-text">
          <circul8-table
            ref="circul8Table"
            @clickcheck="checkCheckBox"
            @checkedAll="checkedAllData"
            :checkedRows="checkedRow"
            :records="tableData"
            :fields="columns.filter(column => column.visible !== false)"
            :usePropRecords="true"
            :listingComponent="true"
            :isCheckable="true"
            :maxTextLength="'24'"
            :isLoading="isDataLoading"
            @querySet="searchByFilter"
            :backendSortingEnabled="true"
            :routeNext="false"
            :showEditButton="isEditAllowed"
            @backendSort="sortData"
            @clickEdit="editModal"
            @clickView="viewModal"
            :showRemoveButton="false"
            @loadNextPage="pullNextPage"
            :enableInfiniteScroll="true"
            :hasNextData="nextData"
            :hasPreviousData="previousData"
            @loadPreviousPage="pullPreviousPage"
            :allProductFamily="productFamily"
            :allMaterialDetail="materialDetail"
            :productFamilyDropDown="productFamilyDropDown"
            :materialDetailDropDown="materialDetailDropDown"
            :chemistryDropDown="chemistryDropDown"
            :packagingTypeDropDown="packagingTypeDropDown"
            :packagingLevelDropDown="packagingLevelDropDown"
          />
          <div class="records-displayed" v-if="totalRecords > 0">
            <span v-if="isCheckedAll"> All selected, </span>
            <span v-if="checkedData.length > 0 && !isCheckedAll"
              >{{ checkedData.length }} selected,
            </span>
            <span v-if="currentPage * 50 + 50 < totalRecords"
              >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
              {{
                currentPage > 0
                  ? nextPageCursor
                    ? currentPage * 50 - 50 + tableData.length
                    : totalRecords
                  : tableData.length
              }}
              records out of {{ totalRecords }} records</span
            >
            <div v-else>
              <span v-if="currentPage == 0">
                displaying 0 - {{ totalRecords }} records out of
                {{ totalRecords }} records
              </span>
              <span v-else>
                displaying {{ currentPage * 50 - 50 }} -
                {{ totalRecords }} records out of {{ totalRecords }} records
              </span>
            </div>
          </div>
          <b-loading
            :is-full-page="true"
            v-model="isLoading"
            :can-cancel="false"
          ></b-loading>
        </div>
      </section>
    </section>
    <single-product-edit
      :is-active="isModalActive"
      :customer-id="Number(this.$route.params.customerId)"
      :action="action"
      :edit-object-name="editObject"
      @confirm="editConfirm"
      @cancel="editCancel"
      :columns="this.columns"
      @updateSingleData="updatedSingleProduct"
      :allProductFamily="productFamily"
      :allMaterialDetail="materialDetail"
      :columnsConfig="this.cdf_product_config_sheet"
      :materialGeneralDropdown="materialGeneralDropdown"
      :chemistryDropDown="chemistryDropDown"
      :packagingTypeDropDown="packagingTypeDropDown"
      :packagingLevelDropDown="packagingLevelDropDown"
    />
    <bulk-product-edit
      :is-active="isCardModalBulkEditActive"
      :customer-id="Number(this.customer.id)"
      @cancel="editBulkCancel"
      :columns="this.columns"
      :columnsConfig="this.cdf_product_config_sheet"
      :checkedRows="this.checkedRow"
      :isCheckedAllRows="this.isCheckedAll"
      :stream="this.stream"
      :tempProduct="false"
      @reload="reloadProductData"
      :query="this.query"
    />
    <bulk-product-export
      @confirm="viewConfirmExport"
      @totalRecords="this.totalRecords"
      @cancel="viewCancel"
      :is-active="isBulkExportModal"
    >
    </bulk-product-export>
    <bulk-comment
      :is-active="isBulkCommentModal"
      @confirm="saveBulkComment"
      @cancel="cancelBulkComment"
    />
    <data-completion
      :columns="this.columns"
      :customer-id="Number(this.customer.id)"
      :columnsConfig="this.cdf_product_sheet"
      :checkedRows="this.checkedRow"
      :isCheckedAllRows="this.isCheckedAll"
      :stream="this.stream"
      :tempProduct="false"
      @reload="reloadProductData"
      :query="this.query"
      :is-active="isDataCompletion"
      @cancel="dataCompletionCancel"
    >
    </data-completion>
    <add-product
      ref="addProductModal"
      :is-active="isAddProductModalActive"
      :customer-id="Number(this.customer.id)"
      :cdf-product-sheet="this.cdf_product_sheet_full"
      :available-streams="this.availableStream"
      :product-family="this.productFamily"
      :material-detail="this.materialDetail"
      :product-group-drop-down="this.productGroupDropDown"
      :product-family-drop-down="this.productFamilyDropDown"
      :material-detail-drop-down="this.materialDetailDropDown"
      :material-general-dropdown="this.materialGeneralDropdown"
      :packaging-type-drop-down="this.packagingTypeDropDown"
      :packaging-level-drop-down="this.packagingLevelDropDown"
      :chemistry-drop-down="this.chemistryDropDown"
      @save="handleAddProduct"
      @close="isAddProductModalActive = false"
    />
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import Multiselect from "vue-multiselect";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import CDFProductDataService from "../../services/CDFProductDataService";
import DataManagementService from "../../services/DataManagementImportService";
import Circul8Table from "../../components/Circul8Table.vue";
import { CDFStream } from "../../constants/CDFStream";
import { FieldType } from "../../constants/FieldType";
import SingleProductEdit from "@/components/DataManagement/SingleProductEdit";
import BulkProductEdit from "@/components/DataManagement/BulkProductEdit";
import BulkProductExport from "@/components/DataManagement/BulkProductExport.vue";
import BulkComment from "@/components/DataManagement/BulkComment.vue";
import DataCompletion from "@/components/DataManagement/DataCompletion.vue";
import AddProduct from "@/components/DataManagement/AddProduct.vue";
import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ProductMixin from "@/mixins/ProductMixin";
import ErrorMixin from "@/mixins/ErrorMixin";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import * as dayjs from "dayjs";
let screenPixelSize;
let pixelRatio;
export default {
  name: "DataManagementProducts",
  mixins: [UtilityMixin, ProductMixin, ErrorMixin, UserPermissionMixin],
  components: {
    HeroBar,
    TitleBar,
    Multiselect,
    Circul8Table,
    SingleProductEdit,
    BulkProductEdit,
    BulkProductExport,
    BulkComment,
    DataCompletion,
    AddProduct
  },
  data() {
    return {
      checkedData: [],
      selectedProductId: null,
      checkedRow: [],
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      isDataLoading: false,
      stream: "PRODUCT SHEET",
      availableStream: {},
      customer: "",
      form: [],
      customers: [],
      tenatSchemas: [],
      cdf_product_sheet: [],
      cdf_product_sheet_full: [],
      customerDataService: new CustomerProfileDataService(),
      CDFProductDataService: new CDFProductDataService(),
      DataManagementService: new DataManagementService(),
      columns: [],
      columnsForConfig: [],
      selectAll: true,
      tableData: [],
      isModalActive: false,
      isBulkExportModal: false,
      isCardModalBulkEditActive: false,
      cdf_product_config_sheet: [],
      editObject: {},
      action: "",
      productFamily: {},
      productGroupDropDown: [],
      productFamilyDropDown: [],
      materialDetailDropDown: [],
      materialGeneralDropdown: [],
      packagingTypeDropDown: [],
      packagingLevelDropDown: [],
      chemistryDropDown: [],
      materialDetail: {},
      subHeight: 315,
      isDataCompletion: false,
      switchCustomerId: null,
      switchCustomerViewEnabled: false,
      isBulkCommentModal: false,
      exportLargeCount: 65000,
      isAddProductModalActive: false,
      pendingSupplierFilter: null
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "mappedCustomer",
      "switchCustomerView"
    ]),
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE)
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    titleStack() {
      return [
        { url: "#", name: "Data Management" },
        { url: "/datamangement/products", name: "Products" }
      ];
    },
    isViewOnlyUser() {
      if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    const hasRouteCustomerId = Object.prototype.hasOwnProperty.call(
      this.$route.params,
      "customerId"
    );
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    if (this.mappedCustomer && this.mappedCustomer.length > 0) {
      this.switchCustomerViewEnabled = true;
      this.getCustomerById();
    } else {
      this.fetchTenantSchemaData();
    }
    if (hasRouteCustomerId || this.switchCustomerId) {
      this.getCustomerById();
    }
    // Keep supplier filters ready so initial table load uses them.
    this.pendingSupplierFilter = this.getRouteSupplierFilter();
  },
  // updated() {
  //   const listElm = document.querySelector(".table-wrapper");
  //   listElm.addEventListener("scroll", e => {
  //     if (
  //       Math.round(listElm.scrollTop) +
  //         Math.round(listElm.clientHeight) -
  //         Math.round(listElm.scrollHeight) >=
  //       -5
  //     ) {
  //       if (this.nextData) {
  //         listElm.scrollTop = 50;
  //         this.pullNextPage();
  //       }
  //     } else {
  //       if (Math.round(listElm.scrollTop) == 0 && this.previousData) {
  //         listElm.scrollTop =
  //           Math.round(listElm.scrollHeight) -
  //           Math.round(listElm.clientHeight) -
  //           50;
  //         this.pullPreviousPage();
  //       }
  //     }
  //     this.checkSize();
  //     this.adjustHeight();
  //   });
  // },
  methods: {
    openAddProductModal() {
      this.isAddProductModalActive = true;
    },
    openSelectProductModal(id) {
      // Get the selected product ID
      this.selectedProductId = id;
      // Call API to fetch product details with streams
      this.isLoading = true;
      this.CDFProductDataService.getProductDetailWithStreams(
        this.selectedProductId,
        this.customer.id
      ).subscribe(
        response => {
          this.isLoading = false;
          // Open the modal first
          this.isAddProductModalActive = true;
          // Then populate the data in the next tick to ensure modal is ready
          this.$nextTick(() => {
            this.$refs.addProductModal.populateFormWithProductData(response);
          });
        },
        e => {
          this.isLoading = false;
          let errorMessage = "Failed to fetch product details";
          if (e?.response?.data?.detail) {
            errorMessage = e.response.data.detail;
          } else if (e?.response?.data?.error) {
            errorMessage = e.response.data.error;
          } else if (e?.message) {
            errorMessage = e.message;
          }
          this.$buefy.dialog.alert({
            title: "Error",
            message: errorMessage,
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
        }
      );
    },
    handleAddProduct(productData) {
      try {
        this.isLoading = true;
        // Call API to save the product
        const customer_id = this.customer.id ? this.customer.id : 0;
        this.DataManagementService.addSingleProductData(
          customer_id,
          productData,
          this.selectedProductId
        ).subscribe(
          () => {
            this.$buefy.toast.open({
              message: "Product added successfully!",
              type: "is-success"
            });
            this.isLoading = false;
            this.isAddProductModalActive = false;
            this.reloadProductData();
          },
          e => {
            console.log(e);
            this.handleApiError(e);
            this.nextData = false;
            this.isDataLoading = false;
          }
        );
      } catch (error) {
        this.isLoading = false;
        let errorMessage = "An error occurred while adding the product";
        if (error?.response?.data?.detail) {
          errorMessage = error.response.data.detail;
        } else if (error?.response?.data?.error) {
          errorMessage = error.response.data.error;
        }
        this.$buefy.dialog.alert({
          title: "Error",
          message: errorMessage,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    openDataCompletionModal() {
      if (this.checkedRow.length || this.isCheckedAll) {
        this.isDataCompletion = true;
      } else {
        this.$buefy.dialog.alert({
          title: "Warning",
          message: "Please choose the record(s) you want to update.",
          confirmText: "Close",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    openRevertModal() {
      if (this.checkedRow.length || this.isCheckedAll) {
        this.isDataCompletion = true;
      }
    },
    dataCompletionCancel(str) {
      if (str !== "reload") {
        this.reloadProductData();
      }
      this.isDataCompletion = false;
    },
    prepareDropDownArray(value) {
      const result = [];

      if (!value || (Array.isArray(value) && value.length === 0)) {
        return result;
      }

      // Handle string arrays
      if (Array.isArray(value) && typeof value[0] === "string") {
        value.forEach(element => {
          const obj = {};
          obj["name"] = element;
          result.push(obj);
        });
      }
      // Handle nested object arrays (like product_family with categories as keys)
      else if (
        Array.isArray(value) &&
        typeof value[0] === "object" &&
        value[0] !== null
      ) {
        const firstItem = value[0];
        // If it's a mapping object with arrays as values (for product_family, material_detail)
        if (Object.keys(firstItem).length > 0) {
          Object.keys(firstItem).forEach(key => {
            const obj = {};
            obj["name"] = key;
            result.push(obj);
          });
        }
      }

      return result;
    },
    saveBulkComment(data) {
      this.isBulkCommentModal = false;
      this.CDFProductDataService.saveBulkComment(
        this.customer.id,
        this.checkedData.map(records => records.id),
        this.query,
        this.isCheckedAll,
        data,
        this.stream
      ).subscribe(
        () => {
          this.checkedData = [];
          this.map1 = new Map();
          this.checkedRow = [];
          this.isCheckedAll = false;
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Comment(s) Created!",
            onConfirm: () => this.getCustomerById()
          });
        },
        e => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: e.message
          });
          this.isLoading = false;
        }
      );
    },
    cancelBulkComment() {
      this.isBulkCommentModal = false;
    },
    BulkComments() {
      if (this.checkedData.length > 0) {
        this.isBulkCommentModal = true;
      } else {
        this.$buefy.dialog.alert({
          title: "Comment is Not Possible",
          message: "Please select at least one record"
        });
      }
    },
    editBulkModal() {
      if (this.checkedData.length > 0 || this.isCheckedAll) {
        this.isCardModalBulkEditActive = true;
      } else {
        this.$buefy.dialog.alert({
          title: "Bulk Edit Not Possible",
          message: "Please select at least one record"
        });
      }
    },
    deactivateBulkModal() {
      if (this.checkedData.length === 0 && !this.isCheckedAll) {
        this.$buefy.dialog.alert({
          title: "Deactivate Not Possible",
          message: "Please select at least one product to deactivate"
        });
        return;
      }

      const count = this.isCheckedAll
        ? this.totalRecords
        : this.checkedData.length;
      this.$buefy.dialog.confirm({
        title: "Deactivate Products",
        message: `Are you sure you want to deactivate ${count} product${
          count > 1 ? "s" : ""
        }?`,
        confirmText: "Deactivate",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.confirmDeactivate()
      });
    },
    confirmDeactivate() {
      this.isLoading = true;
      const productIds = this.isCheckedAll
        ? []
        : this.checkedData.map(record => record.id);

      this.CDFProductDataService.deactivateBulkProducts(
        this.customer.id,
        productIds,
        this.query,
        this.isCheckedAll,
        this.stream
      ).subscribe(
        () => {
          this.$buefy.toast.open({
            message: "Products deactivated successfully!",
            type: "is-success"
          });
          this.checkedData = [];
          this.map1 = new Map();
          this.checkedRow = [];
          this.isCheckedAll = false;
          this.reloadProductData();
          this.isLoading = false;
        },
        e => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              e?.response?.data?.error ||
              e?.message ||
              "Failed to deactivate products"
          });
          this.isLoading = false;
        }
      );
    },
    exportProducts() {
      try {
        this.CDFProductDataService.exportProducts(
          this.customer.id,
          "Products",
          this.stream,
          this.checkedData.map(records => records.id)
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: e.message
        });
      }
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      //this.fetchCDFProductData(this.customer.id);
    },
    revertDataCompletionRule(bulkAction) {
      if (bulkAction == "revert") {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message:
            "Are you sure you want to revert data completion rule on these records?",
          trapFocus: true,
          onConfirm: value => this.revertDc(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    additionalBulkCheck(bulkAction) {
      let msg = "";
      if (this.totalRecords < this.exportLargeCount) {
        msg =
          `Are you sure you want to export ` +
          (this?.isCheckedAll
            ? `all`
            : `selected ` + this?.checkedData?.length) +
          ` records?`;
      } else {
        msg =
          `Are you sure you want to export more than ` +
          this.exportLargeCount +
          ` records? Exported file will be sent to your email address`;
      }
      if (this.checkedData.length > 50 || this.isCheckedAll) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message: msg,
          trapFocus: true,
          onConfirm: value => this.exportAllProducts(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    completeProductExport() {
      let msg = "";
      if (this.totalRecords < this.exportLargeCount) {
        msg = `Are you sure you want to export all records?`;
      } else {
        msg =
          `Are you sure you want to export more than ` +
          this.exportLargeCount +
          ` records? Exported file will be sent to your email address`;
      }
      this.$buefy.dialog.confirm({
        title: "Confirmation",
        confirmText: "Yes",
        message: msg,
        trapFocus: true,
        onConfirm: value => this.exportCompleteProducts(value)
      });
    },
    exportAllProducts() {
      this.isLoading = true;

      this.CDFProductDataService.exportAllProducts(
        this.customer.id,
        "Products",
        this.stream,
        this.query,
        this.totalRecords
      ).subscribe(() => {
        this.isLoading = false;
      }),
        e => {
          this.isLoading = false;
        };
      this.isCheckedAll = false;
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
    },
    exportCompleteProducts() {
      this.isLoading = true;

      this.CDFProductDataService.exportCompleteProducts(
        this.customer.id,
        "Products"
      ).subscribe(() => {
        this.isLoading = false;
      }),
        e => {
          this.isLoading = false;
        };
      this.isCheckedAll = false;
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
    },
    revertDc() {
      this.isLoading = true;
      this.tableData = [];
      this.DataManagementService.dataRevert(this.customer.id, null).subscribe(
        () => {
          this.isLoading = false;
          this.fetchProductData(this.stream, this.query);
        },
        this.handleRevertError
      );
    },
    handleRevertError(reason) {
      let errorMessage = reason.response.data["detail"];
      this.isLoading = false;
      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Some issue while updating status";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.fetchProductData(this.stream, this.query);
    },

    functionCallingMethod(value, bulkAction) {
      this.isCheckedAll = false;
      switch (bulkAction) {
        case "exportProducts":
          this.exportProducts();
          break;
      }
    },
    reloadProductData() {
      this.tableData = [];
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      //this.fetchProductData(this.stream, this.query);
      //this.fetchCDFProductData(this.customer.id, this.query);
      this.fetchProductData(this.stream, this.query);
    },
    editConfirm() {
      this.isModalActive = false;
      this.getCustomerById();
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    editBulkCancel() {
      this.isCardModalBulkEditActive = false;
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
    },
    viewConfirmExport() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    viewCancel() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    viewModal(editObject) {
      this.action = "View";
      this.editObject = editObject;
      this.checkDependency(editObject);
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.action = "Edit";
      if (this.stream === CDFStream.PRODUCT_SHEET) {
        this.openSelectProductModal(editObject.id);
      } else {
        this.editObject = editObject;
        this.checkDependency(editObject);
        this.isModalActive = true;
      }
    },
    find_column_index(column_name) {
      return this.columns.findIndex(col => col.field === column_name);
    },
    pushValueToColumn(index, column_name, flag) {
      this.columns[index]["allStatusVals"] = [];
      if (
        flag == "materialDetail" &&
        this.materialDetail[`${column_name}`] &&
        this.materialDetail[`${column_name}`].length > 0
      ) {
        for (const element of this.materialDetail[`${column_name}`]) {
          this.columns[index]["allStatusVals"].push({
            name: element
          });
        }
      }
      if (
        flag == "productFamily" &&
        this.productFamily[`${column_name}`] &&
        this.productFamily[`${column_name}`].length > 0
      ) {
        for (const element of this.productFamily[`${column_name}`]) {
          this.columns[index]["allStatusVals"].push({
            name: element
          });
        }
      }
    },
    checkDependency(item) {
      const ProductFamilyIndex = this.find_column_index("product_family");
      if (ProductFamilyIndex > 0) {
        this.pushValueToColumn(
          ProductFamilyIndex,
          item.product_group,
          "productFamily"
        );
      }
      const materialDetailIndex = this.find_column_index("material_detail");
      if (materialDetailIndex > 0) {
        this.pushValueToColumn(
          materialDetailIndex,
          item.material_general,
          "materialDetail"
        );
      }
    },
    updatedSingleProduct(editedObject) {
      this.DataManagementService.getOrUpdateProductData(
        this.customer.id,
        this.stream,
        this.$route.params.id,
        "",
        "",
        editedObject,
        true
      ).subscribe(response => {
        this.$buefy.toast.open({
          message: "Data is updated successfully!",
          type: "is-success"
        });
        this.getCustomerById();
        this.isModalActive = false;
      }, this.handleApiError);
    },
    getCustomerById() {
      const hasRouteCustomerId = Object.prototype.hasOwnProperty.call(
        this.$route.params,
        "customerId"
      );
      let customerId = hasRouteCustomerId
        ? Number(this.$route.params.customerId)
        : this.customer.id;
      if (!hasRouteCustomerId && this.switchCustomerId) {
        customerId = this.switchCustomerId;
      }
      if (!hasRouteCustomerId && this.mappedCustomer.length > 0) {
        customerId = this.mappedCustomer[0];
      }
      if (customerId > 0) {
        this.customerDataService.getCustomerById(customerId).subscribe(
          response => {
            this.isLoading = false;
            this.customer = response;
            this.changeCustomer();
          },
          e => {
            this.handleApiError(e);
            this.isLoading = false;
          }
        );
      } else {
        // Handle Public customer (ID = 0)
        // Find the Public customer from tenatSchemas if available
        if (this.tenatSchemas && this.tenatSchemas.length > 0) {
          const publicCustomer = this.tenatSchemas.find(
            schema => schema.id === 0 || schema.name === "Public"
          );
          if (publicCustomer) {
            this.customer = publicCustomer;
            this.changeCustomer();
          } else {
            // Fallback: create a Public customer object
            this.customer = { id: 0, name: "Public" };
            this.changeCustomer();
          }
        } else {
          // tenatSchemas not yet loaded, fetch it first then select Public
          this.customerDataService.getParentCustomerListWithPublic().subscribe(
            response => {
              const data = response.sort((a, b) => (a.name > b.name ? 1 : -1));
              this.tenatSchemas = data;
              const publicCustomer = data.find(
                schema => schema.id === 0 || schema.name === "Public"
              );
              this.customer = publicCustomer || { id: 0, name: "Public" };
              this.changeCustomer();
            },
            e => {
              // Fallback to creating Public customer object
              this.customer = { id: 0, name: "Public" };
              this.changeCustomer();
            }
          );
        }
      }
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.fetchProductData(this.stream, this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchProductData(this.stream, this.query, "prev");
    },
    checkedAllData(value) {
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRow = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.tableData);
      }
    },
    checkCheckBox(d) {
      // select all should be false now
      const total_checked = this.checkedData.length;
      const indexes = [];
      //getting the index of the checked rows
      d.forEach(element => {
        const index = this.tableData.findIndex(object => {
          return element.id === object.id;
        });
        indexes.push(index);
      });
      // create 2 dictionary. one with indexes for showing current page selected another with checked row value
      this.map1.set(this.currentPage, indexes);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRow = d;
      this.checkedData = [];
      // converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // if checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      }
    },
    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      this.query = "&" + filterQuery;

      let query = "";
      // Maintaining sort column & order in separate varaibles instead of this.query as it becomes difficult to replace & maintain
      // sort column & order part of this.query string. We should maintain query params in associative array instead of string
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn + "&";
        query += "&order_by" + "=" + this.lastSortOrder + "&";
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchProductData(this.stream, query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "&order_field" + "=" + field + "&";
      const newOrderValue = "&order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchProductData(this.stream, this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    changeCustomer() {
      this.columns = [];
      this.tableData = [];
      this.totalRecords = 0;
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      this.fetchCDFProductData(this.customer.id);
    },
    changeStream() {
      this.query = "";
      this.isCheckedAll = false;
      this.checkedDataMap = new Map();
      this.checkedData = [];
      this.checkedRow = [];
      this.map1 = new Map();
      this.tableData = [];
      this.totalRecords = 0;
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.nextData = false;
      this.$refs.circul8Table.clearDataWithoutReload();
      // Call prepareColumns with the new stream to ensure proper column visibility settings
      this.prepareColumns(this.cdf_product_sheet, this.stream);
    },

    saveFieldConfig() {
      // Get visible column fields in array format for better compatibility
      const visibleFields = this.columns
        .filter(column => column.visible && column.field !== "actions")
        .map(column => column.field);

      // Create a storage key that includes URL parameter (customerId), user ID, and stream
      const customerId = this.$route.params.customerId || this.customer.id;
      const storageKey = `product-field-config-${
        this.userId
      }-customer-${customerId}-stream-${this.stream.replace(/\s+/g, "_")}`;

      // Save to localStorage
      localStorage.setItem(storageKey, JSON.stringify(visibleFields));

      // Update selectAll based on whether all columns are visible
      const allSelected = this.columns
        .filter(column => column.field !== "actions")
        .every(column => column.visible);
      this.selectAll = allSelected;

      // Force a re-render and recalculate the height
      this.$forceUpdate();

      // After DOM update, recalculate the table height to fill available space
      this.$nextTick(() => {
        this.adjustHeight();
      });
    },

    toggleSelectAll() {
      this.columns.forEach(column => {
        if (column.field !== "actions") {
          column.visible = this.selectAll;
        }
      });
      this.columnsForConfig = [...this.columns];
      this.saveFieldConfig();
    },

    prepareColumns(data, stream = 1) {
      // dynamically generate columns based on customer and stream
      const cdf_columns = data[0]["template_fields"];
      let cdf_product_sheet = [];
      if (stream == CDFStream.BATT) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BATT
        );
      } else if (stream == CDFStream.PACK) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PACK
        );
      } else if (stream == CDFStream.WEEE) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.WEEE
        );
      } else if (stream == CDFStream.BUNDLE) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BUNDLE
        );
      } else {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PRODUCT_SHEET
        );
      }
      this.columns = [];
      this.tableData = [];

      // Create a storage key that includes URL parameter (customerId), user ID, and stream
      const customerId = this.$route.params.customerId || this.customer.id;
      const storageKey = `product-field-config-${
        this.userId
      }-customer-${customerId}-stream-${this.stream.replace(/\s+/g, "_")}`;

      // Get saved configuration using the key format
      let savedConfig = localStorage.getItem(storageKey);

      // If no saved config is found for this specific combination, check for older formats (for backward compatibility)
      if (!savedConfig) {
        // Try user-specific but without stream
        savedConfig = localStorage.getItem(
          `product-field-config-${this.userId}-customer-${customerId}`
        );

        // If still not found, try the legacy format
        if (!savedConfig) {
          savedConfig = localStorage.getItem(
            `product-field-config-${customerId}`
          );
        }
      }

      // Parse the saved configuration if it exists
      const savedFieldConfig = savedConfig ? JSON.parse(savedConfig) : null;

      cdf_product_sheet.forEach(e => {
        if (
          e.field_name == "WEEE" ||
          e.field_name == "BATT" ||
          e.field_name == "PACK" ||
          e.field_name == "COPY" ||
          e.field_name == "BUNDLE"
        ) {
          this.availableStream[e.field_name] = e.field_required;
        }
        if (
          (e.sheet_name == "BUNDLE INFORMATION") &
          (e.field_required == true)
        ) {
          this.availableStream["BUNDLE"] = true;
        }
        if (e.field_required == false) {
          return;
        }
        let type = "";
        let multiSelectFilter = "false";
        type = this.getFieldType(e.field_type);
        const filterKey = {};
        let allStatusVals = [];
        if (e.dropdown_field_values?.length > 0) {
          e.dropdown_field_values.forEach(element => {
            if (e.product_data_column == "product_family") {
              Object.keys(element).forEach(key => {
                this.productFamily[`${key}`] = [];
              });
              this.productFamilyDropDown.forEach(val => {
                Object.keys(element).forEach(key => {
                  const value = element[key];
                  if (value.includes(val.name)) {
                    this.productFamily[`${key}`].push(val.name);
                  }
                });
              });
              allStatusVals = this.productFamilyDropDown;
            } else if (e.product_data_column == "material_detail") {
              Object.keys(element).forEach(key => {
                this.materialDetail[`${key}`] = [];
              });
              this.materialDetailDropDown.forEach(val => {
                Object.keys(element).forEach(key => {
                  const value = element[key];
                  if (value.includes(val.name)) {
                    this.materialDetail[`${key}`].push(val.name);
                  }
                });
              });
              allStatusVals = this.materialDetailDropDown;
            } else {
              allStatusVals.push({ name: element });
            }
          });
        }
        if (e.product_data_column == "product_group") {
          allStatusVals = this.productGroupDropDown;
        }
        if (e.product_data_column == "material_general") {
          allStatusVals = this.materialGeneralDropdown;
        }
        if (e.product_data_column == "packaging_type") {
          allStatusVals = this.packagingTypeDropDown;
        }
        if (e.product_data_column == "packaging_level") {
          allStatusVals = this.packagingLevelDropDown;
        }
        if (e.product_data_column == "chemistry") {
          allStatusVals = this.chemistryDropDown;
        }
        const editableCheck = e?.editable_check ? e.editable_check : false;
        const field_name = e.product_data_column;
        const label_name =
          e.field_name.charAt(0).toUpperCase() +
          e.field_name.slice(1).toLowerCase();
        if (type == "multiSelectFilter") {
          multiSelectFilter = "true";
          filterKey[field_name] = [];
          filterKey["field_name"] = "name";
        } else {
          filterKey[field_name] = "";
        }
        // Determine column visibility - default to visible (true) if no saved config
        let visible = true;

        // If we have a saved configuration, use it to determine visibility
        if (savedFieldConfig) {
          // For array format (new format)
          if (Array.isArray(savedFieldConfig)) {
            visible = savedFieldConfig.includes(field_name);
          }
          // For object format (old format)
          else {
            visible = savedFieldConfig[field_name] !== false;
          }
        } else {
          // If no saved config exists, all columns should be visible by default
          visible = true;
        }

        this.columns.push({
          field: field_name,
          label: label_name,
          searchable: true,
          width: "300",
          filterKey: filterKey,
          type: type,
          multiSelectFilter: multiSelectFilter,
          initStatusVals: [],
          allStatusVals: allStatusVals,
          editableCheck: editableCheck,
          visible: visible
        });
      });
      this.columns.sort((a, b) => a?.template_field - b?.template_field);
      this.columns.push({
        field: "external_comment",
        label: "External User Comment",
        searchable: true,
        additionalInfo: true,
        additionalInfoIcon: "mdi  mdi-information",
        additionalInfoFieldName: "external_comment",
        filterKey: { external_comment: "" },
        type: "input",
        width: "300",
        visible: savedFieldConfig
          ? Array.isArray(savedFieldConfig)
            ? savedFieldConfig.includes("external_comment")
            : savedFieldConfig["external_comment"] !== false
          : true
      });
      if (stream !== "Transactions") {
        this.columns.push({
          field: "dc_applied",
          label: "Data Completion Applied",
          additionalInfo: true,
          editableCheck: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "dc_error",
          searchable: true,
          filterKey: {
            dc_applied: [],
            field_name: "name"
          },
          type: "multiSelectFilter",
          multiSelectFilter: true,
          allStatusVals: [{ name: "yes" }, { name: "no" }],
          width: "200",
          visible: savedFieldConfig
            ? Array.isArray(savedFieldConfig)
              ? savedFieldConfig.includes("dc_applied")
              : savedFieldConfig["dc_applied"] !== false
            : true
        });
        this.columns.push({
          field: "data_comp_rules",
          label: "Data Completion Rule",
          searchable: true,
          editableCheck: true,
          width: "300",
          filterKey: { data_comp_rules: "" },
          type: "input",
          visible: savedFieldConfig
            ? Array.isArray(savedFieldConfig)
              ? savedFieldConfig.includes("data_comp_rules")
              : savedFieldConfig["data_comp_rules"] !== false
            : true
        });
        this.columns.push({
          field: "dc_created_at",
          label: "Data Completion Created At",
          searchable: true,
          editableCheck: true,
          filterKey: { dc_created_at: "" },
          type: "dateField",
          dateField: true,
          dateFilterKey: "dc_created_at_key",
          width: "200",
          visible: savedFieldConfig
            ? Array.isArray(savedFieldConfig)
              ? savedFieldConfig.includes("dc_created_at")
              : savedFieldConfig["dc_created_at"] !== false
            : true
        });
        this.columns.push({
          field: "dc_by_name",
          label: "Data Completion Created By",
          editableCheck: true,
          searchable: true,
          filterKey: { dc_by_name: "" },
          type: "input",
          width: "200",
          visible: savedFieldConfig
            ? Array.isArray(savedFieldConfig)
              ? savedFieldConfig.includes("dc_by_name")
              : savedFieldConfig["dc_by_name"] !== false
            : true
        });
      }
      this.columns.push({
        field: "is_matching_required",
        label: "Matching Required",
        searchable: true,
        filterKey: {
          is_matching_required: [],
          field_name: "name"
        },
        type: "multiSelectFilter",
        multiSelectFilter: true,
        allStatusVals: [{ name: "true" }, { name: "false" }],
        width: "200",
        visible: savedFieldConfig
          ? Array.isArray(savedFieldConfig)
            ? savedFieldConfig.includes("is_matching_required")
            : savedFieldConfig["is_matching_required"] !== false
          : true
      });
      this.columns.push({
        field: "created_at",
        label: "Imported Date",
        searchable: true,
        filterKey: { created_at: "" },
        type: "dateField",
        editableCheck: true,
        dateField: true,
        width: "200",
        visible: savedFieldConfig
          ? Array.isArray(savedFieldConfig)
            ? savedFieldConfig.includes("created_at")
            : savedFieldConfig["created_at"] !== false
          : true
      });
      this.columns.push({
        field: "updated_at",
        label: "Updated Date",
        editableCheck: true,
        searchable: true,
        filterKey: { updated_at: "" },
        type: "dateField",
        dateField: true,
        width: "200",
        visible: savedFieldConfig
          ? Array.isArray(savedFieldConfig)
            ? savedFieldConfig.includes("updated_at")
            : savedFieldConfig["updated_at"] !== false
          : true
      });
      this.columns.push({
        field: "created_by_name",
        editableCheck: true,
        label: "Created By",
        searchable: true,
        filterKey: { created_by_name: "" },
        type: "input",
        width: "200",
        visible: savedFieldConfig
          ? Array.isArray(savedFieldConfig)
            ? savedFieldConfig.includes("created_by_name")
            : savedFieldConfig["created_by_name"] !== false
          : true
      });
      this.columns.push({
        field: "updated_by_name",
        label: "Updated By",
        editableCheck: true,
        searchable: true,
        filterKey: { updated_by_name: "" },
        type: "input",
        width: "200",
        visible: savedFieldConfig
          ? Array.isArray(savedFieldConfig)
            ? savedFieldConfig.includes("updated_by_name")
            : savedFieldConfig["updated_by_name"] !== false
          : true
      });
      this.columns.push({
        field: "actions",
        label: "",
        sortable: 1,
        headerClass: "is-actions",
        cellClass: "is-actions",
        visible: true, // Always keep actions column visible
        searchable: true,
        type: "actionSearch",
        actionSearch: true,
        filterKey: { actions: "" }
      });
      // Update columnsForConfig for the dropdown
      this.columnsForConfig = [...this.columns];

      // Initialize selectAll based on current column visibility
      this.selectAll = this.columns
        .filter(column => column.field !== "actions")
        .every(column => column.visible);

      if (this.pendingSupplierFilter) {
        this.syncSupplierFilterState(this.pendingSupplierFilter);
      }

      this.fetchProductData(stream, this.query);
      this.cdf_product_config_sheet = cdf_product_sheet;
    },

    getFieldType(value) {
      switch (value) {
        case FieldType.TEXT:
          return "input";
        case FieldType.DATE:
          return "dateField";
        case FieldType.NUMBER:
          return "input";
        case FieldType.DROPDOWN:
          return "multiSelectFilter";
        case FieldType.NUMBERRANGE:
          return "numberRange";
        default:
          return "input";
      }
    },

    fetchProductData(stream, query = "", scrollDir) {
      this.isDataLoading = true;
      this.DataManagementService.getOrUpdateProductData(
        this.customer.id,
        stream,
        this.$route.params.id,
        "",
        query
      ).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }

          // if (this.loadMoreClicked) {
          //   this.displayedRecords += response["results"].length;
          // }
          this.totalRecords = response["count"];
          //this.tableData = response["results"];
          let tempData = [];
          if (scrollDir == "next") {
            if (!this.nextPageCursor) {
              this.prepareData(response["results"], scrollDir);
            } else {
              tempData = [...this.tableData, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.tableData];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"]);
          }

          this.isDataLoading = false;
        },
        e => {
          this.nextData = false;
          this.isDataLoading = false;
          let errorMessage = "An error occurred while fetching product data.";
          if (e?.response?.data?.detail) {
            errorMessage = e.response.data.detail;
          } else if (e?.response?.data?.error) {
            errorMessage = e.response.data.error;
          }
          this.$buefy.dialog.alert({
            title: "Error",
            message: errorMessage,
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
        }
      );
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["updated_at"] = dayjs(reportData["updated_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        reportData["created_at"] = dayjs(reportData["created_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        if (reportData["dc_created_at"]) {
          reportData["dc_created_at"] = dayjs(
            reportData["dc_created_at"]
          ).format("YYYY-MM-DD, HH:mm");
        }
        reportData["actions"] = true;
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        this.tableData.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.tableData = dataList;
      }
      //if select all checkbox clicked the show all the data for the page as checked
      if (this.isCheckedAll) {
        this.checkedRow = this.tableData;
      } else {
        //else show the corresponding data from the dictionay map1
        const temp = [];
        // check if dictionary has value or not
        if (
          this.map1.get(this.currentPage) &&
          this.map1.get(this.currentPage).length > 0
        ) {
          //inserting data according to index of the current page
          this.map1.get(this.currentPage).forEach(element => {
            temp.push(this.tableData[element]);
          });
          this.checkedRow = temp;
        } else {
          this.checkedRow = [];
        }
      }
      this.checkSize();
      this.adjustHeight();
      this.isDataLoading = false;
    },
    fetchCDFProductData(customer_id) {
      this.isDataLoading = true;
      // First, fetch the additional dropdowns
      this.DataManagementService.getAdditionalDropdowns(customer_id).subscribe(
        dropdownResponse => {
          // Populate the dropdown arrays
          this.productFamilyDropDown = this.prepareDropDownArray(
            dropdownResponse.product_family || []
          );
          this.productGroupDropDown = this.prepareDropDownArray(
            dropdownResponse.product_group || []
          );
          this.materialDetailDropDown = this.prepareDropDownArray(
            dropdownResponse.material_detail || []
          );
          this.materialGeneralDropdown = this.prepareDropDownArray(
            dropdownResponse.material_general || []
          );
          this.packagingTypeDropDown = this.prepareDropDownArray(
            dropdownResponse.packaging_type || []
          );
          this.packagingLevelDropDown = this.prepareDropDownArray(
            dropdownResponse.packaging_level || []
          );
          this.chemistryDropDown = this.prepareDropDownArray(
            dropdownResponse.chemistry || []
          );

          // Now fetch the CDF product sheet data
          this.CDFProductDataService.getAll(customer_id, true).subscribe(
            response => {
              this.cdf_product_sheet = response;
              this.cdf_product_sheet_full = response;
              if (response.length > 0) {
                this.prepareColumns(response, this.stream);
              }
              this.isDataLoading = false;
            },
            e => {
              console.error("Error fetching CDF product data:", e);
              this.isDataLoading = false;
            }
          );
        },
        e => {
          console.error("Error fetching dropdowns:", e);
          // Still proceed with CDF data fetch even if dropdowns fail
          this.CDFProductDataService.getAll(customer_id, true).subscribe(
            response => {
              this.cdf_product_sheet = response;
              this.cdf_product_sheet_full = response;
              if (response.length > 0) {
                this.prepareColumns(response, this.stream);
              }
              this.isDataLoading = false;
            },
            e => {
              console.error("Error fetching CDF product data:", e);
              this.isDataLoading = false;
            }
          );
        }
      );
    },
    fetchCustomerData() {
      this.isDataLoading = true;
      this.customerDataService.getParentCustomerList().subscribe(
        response => {
          const data = response.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.customers = data;
          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    fetchTenantSchemaData() {
      this.isDataLoading = true;
      this.customerDataService.getParentCustomerListWithPublic().subscribe(
        response => {
          const data = response.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.tenatSchemas = data;
          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    backToImportForm() {
      this.$router.push({
        name: "datamanagement.importform",
        params: {
          customer: this.customer,
          importType: { id: "1", name: "Products" }
        }
      });
    },
    checkSize() {
      screenPixelSize = screen.width;
      pixelRatio =
        window.devicePixelRatio ||
        window.screen.availWidth / document.documentElement.clientWidth;
      pixelRatio = pixelRatio.toFixed(1);
      if (
        (screenPixelSize > 1024 &&
          screenPixelSize < 1281 &&
          pixelRatio == 1.5) ||
        (screenPixelSize > 1580 && screenPixelSize < 1921 && pixelRatio == 1.5)
      ) {
        this.subHeight = this.subHeight - 15;
      }
      this.$refs.circul8Table.$refs.multiselect &&
        this.$refs.circul8Table.$refs.multiselect.forEach(element => {
          element.deactivate();
        });
      this.$refs.circul8Table.$refs.dropdown &&
        this.$refs.circul8Table.$refs.dropdown.forEach(element => {
          element.isActive = false;
        });
      this.$refs.circul8Table.$refs.datePicker &&
        this.$refs.circul8Table.$refs.datePicker.forEach(element => {
          element.closePopup();
        });
    },

    adjustHeight() {
      const browser_height = window.innerHeight;
      const newTableHeight = browser_height - this.subHeight;
      document.querySelector(".table-wrapper").style.maxHeight =
        newTableHeight + "px";
    },
    getRouteSupplierFilter() {
      if (
        !this.$route.query.supplier_number &&
        !this.$route.query.supplier_name &&
        !this.$route.query.supplier_id
      ) {
        return null;
      }

      return {
        supplierNumber:
          this.$route.query.supplier_number || this.$route.query.supplier_id,
        supplierName: this.$route.query.supplier_name
      };
    },
    buildSupplierFilterQuery(supplierFilter) {
      if (!supplierFilter) {
        return "";
      }

      const supplierNumber =
        typeof supplierFilter === "object"
          ? supplierFilter.supplierNumber
          : supplierFilter;
      const supplierName =
        typeof supplierFilter === "object" ? supplierFilter.supplierName : "";

      return [
        supplierNumber
          ? `supplier_number=${encodeURIComponent(supplierNumber)}`
          : "",
        supplierName ? `supplier_name=${encodeURIComponent(supplierName)}` : ""
      ]
        .filter(Boolean)
        .join("&");
    },
    setColumnFilterValue(fieldName, value) {
      const column = this.columns.find(col => col.field === fieldName);
      if (!column || !column.filterKey) {
        return;
      }

      column.filterKey[fieldName] = value || "";
    },
    syncSupplierFilterState(supplierFilter) {
      const supplierNumber =
        typeof supplierFilter === "object"
          ? supplierFilter.supplierNumber
          : supplierFilter;
      const supplierName =
        typeof supplierFilter === "object" ? supplierFilter.supplierName : "";

      this.setColumnFilterValue("supplier_number", supplierNumber);
      this.setColumnFilterValue("supplier_name", supplierName);

      const filterQuery = this.buildSupplierFilterQuery(supplierFilter);
      this.query = filterQuery ? `&${filterQuery}` : "";
      return filterQuery;
    },
    applySupplierFilter(supplierFilter) {
      // Apply supplier filter with a slight delay to ensure columns are prepared
      setTimeout(() => {
        if (this.columns && this.columns.length > 0) {
          const filterQuery = this.syncSupplierFilterState(supplierFilter);
          this.pendingSupplierFilter = null;

          // Call searchByFilter with the supplier filter
          this.searchByFilter(filterQuery);
        } else {
          // If columns not ready, retry after a delay
          this.pendingSupplierFilter = supplierFilter;
          this.applySupplierFilter(supplierFilter);
        }
      }, 500);
    }
  }
};
</script>
